export const brandFonts = {
  primary: "'Poppins', sans-serif",
  secondary: 'Arial Rounded MT Bold,Helvetica Rounded,Arial,sans-serif',
};
